import { createVfm } from 'vue-final-modal'

export const vfm = createVfm() as any

import { plugin, defaultConfig } from '@formkit/vue'
import config from './formkit.config'

import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import ToastService from 'primevue/toastservice'
import router from '@/router'
import store from '@/store'

import QbIcon from '@/components/ui/QbIcon.vue'

export default function install(Vue: any) {
  Vue.component('QbIcon', QbIcon)
  Vue.use(vfm)
  Vue.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        prefix: 'p',
        darkModeSelector: 'body.dark-theme',
        cssLayer: false
      }
    }
  })
  Vue.use(ToastService)
  Vue.use(router)
  Vue.use(store)
  Vue.use(plugin, defaultConfig(config))
}
